export default "__VITE_ASSET__DeOVwn4s__"